"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'whatsapp.groupForm.title': '添加群组',
    'whatsapp.groupForm.back': '返回',
    'whatsapp.groupForm.cancel': '取消',
    'whatsapp.groupForm.save': '保存',
    'whatsapp.groupForm.name': '群组名称',
    'whatsapp.groupForm.namePlaceholder': '输入群组名称...',
    'whatsapp.groupForm.pinMessage': '置顶消息',
    'whatsapp.groupForm.pinMessagePlaceholder': '要在群组中置顶的消息内容...',
    'whatsapp.groupForm.pinMessageHint': '启用跟踪且机器人是管理员时，此消息将被置顶。',
    'whatsapp.groupForm.nameRequired': '群组名称为必填项。',
    'whatsapp.groupForm.avatar': '头像',
    'whatsapp.groupForm.selectAvatar': '-- 选择头像 --',
    'whatsapp.groupForm.botInstruction': '机器人指令',
    'whatsapp.groupForm.botInstructionPlaceholder': '输入 WhatsApp 机器人指令...',
    'whatsapp.groupForm.inviteMembers': '邀请成员',
    'whatsapp.groupForm.memberPlaceholder': '输入电话号码或 @用户名...',
    'whatsapp.groupForm.addMember': '添加成员',
    'whatsapp.groupForm.noMembersYet': '尚未添加任何成员。',
    'whatsapp.groupForm.createSuccess': '群组创建成功。',
    'whatsapp.groupForm.createFailed': '无法创建群组。',
};
